module.exports = __webpack_public_path__ + "static/media/Untitled_Artwork_3.8d5469aa.png";